const normalizeDigits = (value: string) => {
    return value.replace(/\D/g, '');
};

export const normalizeCardNumberInput = (value?: string) => {
    if (!value) {
        return '';
    }

    return normalizeDigits(value);
};

export const formatCardNumber = (value?: string) => {
    if (!value) {
        return '';
    }

    const digits = normalizeCardNumberInput(value);

    return digits.match(/\d{1,4}/g)?.join(' ') ?? '';
};

export const formatCardNumberInput = (value?: string) => {
    return formatCardNumber(value);
};
